import React from "react";
import styles from "./SliderModal.module.scss";
import useWindowSize from "../../../hooks/useWindowSize";
import CloseModalOpacity from "../../icons/profile/closeModalOpacity";

interface IModalBody {
  children: React.ReactNode;
  duration: number;
  state: string;
  setOpenModal: (value: boolean) => void;
  variant?: "default" | "review";
}

const ModalBody = ({ children, duration, state, setOpenModal, variant = "default" }: IModalBody) => {
  const { windowSize } = useWindowSize();
  const isMobile = windowSize === "mobile";
  const isReview = variant === "review";

  const defaultStyle = {
    transition: `transform ${duration}ms ease-in-out`,
    transform: isMobile ? "translateY(200%)" : "translateX(101%)", // Начальная позиция
  };

  const transitionStyles = {
    entering: { transform: isMobile ? "translateY(100%)" : "translateX(101%)" },
    entered: { transform: isMobile ? "translateY(100%)" : "translateX(0)" },
  };
  return (
    <div
      className={`${styles.sidebar} ${isReview ? styles.reviewSidebar : ""}`}
      style={{
        ...defaultStyle, //@ts-ignore
        ...transitionStyles[state],
      }}
    >
      {!isMobile ? (
        <button
          type="button"
          className={styles.closeButton}
          onClick={() => setOpenModal(false)}
        >
          <CloseModalOpacity/>
        </button>
      ) : ''}
      <div
        className={`${styles.sidebarHolder} ${isReview ? styles.reviewSidebarHolder : ""}`}
      >
        {children}
      </div>
      </div>
      );
      };

      export default ModalBody;
